import React from 'react';
import CustomRadioStyle from 'nucleus-core/less/cv/RadiobuttonInput.less';
import FormBase from 'nucleus-core/less/cv/Forms.less';
import RadioButton from 'nucleus-core/forms/elements/RadioButton';
import { injectTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';
import MultiSelectDropDown from 'nucleus-core/forms/elements/MultiSelectDropDown';
import StyleGroup from 'nucleus-core/containers/StyleGroup';
import SelectStyle from 'nucleus-core/less/cv/Select.less';
import multiSelectStyles from 'nucleus-core/less/cv/MultiSelect.less';
import { resolve } from '@cvent/nucleus-dynamic-css';
import ThemeableComponent from 'nucleus-widgets/lib/ThemeableComponent';
import { CCPA_OPTOUT_OPTIONS, DIALOG_MODE, BUTTON_TEXT } from '../../utils/ccpaUtils.js';
import Button from 'nucleus-core/buttons/Button';
import formatAttendeeName from '../../utils/formatAttendeeName.js';

const CustomFormStyles = {
  ...CustomRadioStyle,
  ...FormBase
};


const FormStyles = {
  ...FormBase,
  ...SelectStyle
};

const MultiSelectClasses = {
  ...multiSelectStyles,
  trigger: {
    trigger: multiSelectStyles.trigger
  },
  menu: {
    ...multiSelectStyles,
    checkbox: {
      label: {
        label: FormStyles.label,
        hidden: FormStyles.hidden
      }
    }
  }
};

const CvMultiSelectyle = {
  ...FormStyles,
  multiselect: MultiSelectClasses
};


export default class CCPADialogContent extends ThemeableComponent {
  static displayName = 'CCPADialogContent';
  static propTypes = {
    primaryEventRegistrationInfo: PropTypes.object,
    isAttendeeRegistered: PropTypes.bool,
    guestsEventRegistrationsInfo: PropTypes.array,
    qualifyingQuestionText: PropTypes.string,
    qualifyingErrorText: PropTypes.string,
    successfulOptOutText: PropTypes.string,
    unregisteredForEventText: PropTypes.string,
    instructionalText: PropTypes.string,
    style: PropTypes.object,
    setOptOutRadioOptions: PropTypes.func,
    updateGuests: PropTypes.func,
    handleDialogConfirmationClick: PropTypes.func,
    dialogMode: PropTypes.string
  }

  constructor(props) {
    super(props);
    const getMultiSelectOptions = props.guestsEventRegistrationsInfo.map((item) => {
      return {
        name: formatAttendeeName(item),
        checked: false,
        value: item.attendeeEntityId
      };
    });

    this.state = {
      guests: getMultiSelectOptions,
      ccpaOptOutRadioValue: CCPA_OPTOUT_OPTIONS.YES
    };

    // we need to store the initial radio button value in parent component
    this.props.setOptOutRadioOptions(this.state.ccpaOptOutRadioValue);
  }

  ccpaOptOutRadioChange = (fieldName, newValue) => {
    this.setState({ ccpaOptOutRadioValue: newValue });
    this.props.setOptOutRadioOptions(newValue);
  };

  onGuestsSelection = (fieldName, newValue, newOptions) => {
    this.setState({ guests: newOptions });
    this.props.updateGuests(newOptions);
  };

  getCCPAOptOutContent = (isAttendeeRegistered, translate, style) => {
    const { qualifyingQuestionText, successfulOptOutText, unregisteredForEventText,
      instructionalText, dialogMode, qualifyingErrorText } = this.props;
    if (dialogMode === DIALOG_MODE.SUCCESS_OPT_OUT) {
      return (
        <div {...resolve({ ...this.props, style }, 'mainText')}>
          {translate(successfulOptOutText)}
        </div>
      );
    } else if (dialogMode === DIALOG_MODE.FAILURE_OPT_OUT) {
      return (
        <div {...resolve({ ...this.props, style }, 'mainText')}>
          {translate('EventWidgets_Ccpa_FailureOptOutText__resx')}
        </div>
      );
    } else if (dialogMode === DIALOG_MODE.ADMIN_REG) {
      return (
        <div {...resolve({ ...this.props, style }, 'mainText')}>
          {translate('EventWidgets_Ccpa_AdminRegText__resx')}
        </div>
      );
    } else if (dialogMode === DIALOG_MODE.SHOW_NO_CALAFORNIA_RESIDENT) {
      return (
        <div {...resolve({ ...this.props, style }, 'mainText', 'defaultSpacing')}>
          {translate(qualifyingErrorText)}
        </div>
      );
    } else if (isAttendeeRegistered) {
      return (<>
        <div
          {...resolve({ ...this.props, style }, 'mainText', 'defaultSpacing')}
          dangerouslySetInnerHTML={{ __html: translate(instructionalText) }}>
        </div>

        {dialogMode === DIALOG_MODE.SHOW_QUALIFYING_QUESTION &&
          <div {...resolve({ ...this.props, style }, 'qualifyingQuestionSpacing')}>
            <RadioButton
              label={translate(qualifyingQuestionText)}
              fieldName="type-askQualifyingQuestion"
              name="type-askQualifyingQuestion"
              classes={CustomFormStyles}
              display="vertical"
              style={style}
              options={{
                selectedValue: this.state.ccpaOptOutRadioValue,
                optionArray: [
                  { name: translate('EventWidgets_GenericText_Yes__resx'), value: CCPA_OPTOUT_OPTIONS.YES },
                  { name: translate('EventWidgets_GenericText_No__resx'), value: CCPA_OPTOUT_OPTIONS.NO }
                ]
              }}
              onChange={this.ccpaOptOutRadioChange} />
          </div>
        }
        {(dialogMode === DIALOG_MODE.SHOW_USER_INFO) &&
          <>
            <div {...resolve({ ...this.props, style }, 'label', 'defaultSpacing')}>
              {translate('EventWidgets_VerifyDetails_CCPA__resx')}
            </div>
            <div {...resolve({ ...this.props, style }, 'label', 'defaultSpacing')}>
              {translate('EventWidgets_Fields_FirstName__resx')}
            </div>
            <div {...resolve({ ...this.props, style }, 'input')}>
              {this.props.primaryEventRegistrationInfo.firstName}
            </div>
            <div {...resolve({ ...this.props, style }, 'label', 'defaultSpacing')}>
              {translate('EventWidgets_Fields_LastName__resx')}
            </div>
            <div {...resolve({ ...this.props, style }, 'input')}>
              {this.props.primaryEventRegistrationInfo.lastName}
            </div>
            {
              this.props.primaryEventRegistrationInfo.emailAddress &&
              <>
                <div {...resolve({ ...this.props, style }, 'label', 'defaultSpacing')}>
                  {translate('EventWidgets_Fields_EmailAddress__resx')}
                </div>
                <div {...resolve({ ...this.props, style }, 'input')}>
                  {this.props.primaryEventRegistrationInfo.emailAddress}
                </div>
              </>
            }
            {
              this.state.guests && this.state.guests.length > 0 &&
              <div {...resolve({ ...this.props }, 'multiselectGuests')}>
                <div {...resolve({ ...this.props, style }, 'label', 'selectGuestToOptOut')}>
                  {translate('EventWidgets_SelectGuests_CCPA__resx')}
                </div>
                <StyleGroup classes={{ ...CvMultiSelectyle, ...this.props.classes }}>
                  <MultiSelectDropDown
                    fieldName="guests"
                    options={this.state.guests}
                    onChange={this.onGuestsSelection}
                    {...injectTestId('multi-select-in-global-styles')}
                    selectedTextCallback={count => `${count} ${translate('EventWidgets_GroupFlights_Selected__resx')}`}
                    enableSelectAll={false}
                    enableDeselectAll={false}
                    enableFilter={false}
                  />
                </StyleGroup>
              </div>
            }
          </>
        }
      </>
      );
    }
    return (
      <div {...resolve({ ...this.props, style }, 'mainText', 'defaultSpacing')}>
        {translate(unregisteredForEventText)}
      </div>
    );
  }
  render() {
    const { isAttendeeRegistered, translate, dialogMode, style, classes, handleDialogConfirmationClick } = this.props;

    return (
      <>
        <div>
          {this.getCCPAOptOutContent(isAttendeeRegistered, translate, style)}
        </div>
        <Button
          classes={classes}
          title={translate(BUTTON_TEXT[dialogMode])}
          style={{ ...style, button: style.button }}
          kind="primary"
          onClick={handleDialogConfirmationClick}
        />
      </>
    );
  }
}
